import { cn } from '@/shared/lib/utils'

const BARS = 8

export function Spinner({ className }: { className?: string }) {
  return (
    <svg
      className={cn('size-6 text-app-primary-600', className)}
      viewBox="0 0 24 24"
      fill="none"
    >
      {Array.from({ length: BARS }, (_, i) => {
        const angle = (360 / BARS) * i
        const delay = -(BARS - i) * (1 / BARS)
        return (
          <line
            key={i}
            x1="12"
            y1="2"
            x2="12"
            y2="7"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            style={{
              transform: `rotate(${angle}deg)`,
              transformOrigin: 'center',
              opacity: 0,
              animation: `spinner-fade 1s linear ${delay}s infinite`,
            }}
          />
        )
      })}
    </svg>
  )
}
